/**
 * Cookie category types for GDPR consent management
 */
export type CookieCategory = 'necessary' | 'functional' | 'analytics' | 'marketing';

/**
 * Consent preferences for each category
 */
export interface ConsentPreferences {
  necessary: boolean;      // Always true, cannot be disabled
  functional: boolean;      // Parent zone, game settings
  analytics: boolean;       // Reserved for future use
  marketing: boolean;       // Reserved for future use
  timestamp: string;        // ISO 8601 timestamp
  version: string;          // Consent version for tracking policy changes
}

/**
 * Event emitted when consent changes
 */
export interface ConsentChangeEvent {
  preferences: ConsentPreferences;
  changedCategories: CookieCategory[];
}

/**
 * Storage key for consent preferences
 */
export const CONSENT_STORAGE_KEY = 'owlcat_cookie_consent';

/**
 * Current consent version (increment when privacy policy changes)
 */
export const CONSENT_VERSION = '1.0.0';

/**
 * Default consent preferences (all opt-out except necessary)
 */
export const DEFAULT_CONSENT_PREFERENCES: ConsentPreferences = {
  necessary: true,
  functional: false,
  analytics: false,
  marketing: false,
  timestamp: new Date().toISOString(),
  version: CONSENT_VERSION,
};
